import { Injectable } from "@angular/core";
import { DbTableDefinition } from "src/app/_services/persistence/db-persistence/db-table-definition";

@Injectable({
  providedIn: 'root'
})
export class MessageDbTableDefinition extends DbTableDefinition {
    tableName = 'messages';
    tableStructure = `(
       id INTEGER PRIMARY KEY AUTOINCREMENT,  
       text TEXT NOT NULL,
       receivedts BIGINT(20),
       sentts BIGINT(20),
       subject VARCHAR(255),
       senderId BIGINT(20),
       sender VARCHAR(255),
       read BOOLEAN
      );`;

      constructor() {
        super();
        // Add UpdateStatements to Map
        // Table was added in DB Version 22. Add Create Statement for Version 22
        this.updateStatements.set(22, [`CREATE TABLE IF NOT EXISTS ${this.tableName}${this.tableStructure}`]);
        this.updateStatements.set(24, [`CREATE TABLE IF NOT EXISTS ${this.tableName}${this.tableStructure}`]);
      }
}